module.exports = __webpack_public_path__ + "img/19d7a4104cdc59ea9cf560365754bd34.svg";